import React from 'react';
import pt from 'prop-types';
import Scrollbars from 'components/scrollbars';
import Icon from 'components/icon';
import NavGroup from 'components/nav/group';
import StoreIcon from 'components/store/icon';
import UserPhoto from 'components/user/photo';
import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuLabel,
} from 'components/dropdown-menu';
import { confirmNewExperience } from 'components/dashboard-switch';
import './nav.scss';

export default class NavMain extends React.PureComponent {
  static propTypes = {
    nav: pt.object,
    location: pt.object,
    router: pt.object,
  };

  static contextTypes = {
    partner: pt.object.isRequired,
    user: pt.object.isRequired,
    session: pt.object,
    onClickLogout: pt.func.isRequired,
    onClickSwitchPartner: pt.func,
    openModal: pt.func,
  };

  state = {
    storeMenuOpen: false,
    stopStoreMenuPropagation: true,
    footerMenuOpen: false,
    stopMenuPropagation: true,
  };

  onStoreMenuChange = (open) => {
    this.setState({ storeMenuOpen: open });

    // Prevents propagation when the menu sits on top
    // of the trigger and contains clickable items
    if (open) {
      setTimeout(() => {
        this.setState({ stopStoreMenuPropagation: false });
      }, 150);
    } else {
      this.setState({ stopStoreMenuPropagation: true });
    }
  };

  onFooterMenuChange = (open) => {
    this.setState({ footerMenuOpen: open });

    // Prevents propagation when the menu sits on top
    // of the trigger and contains clickable items
    if (open) {
      setTimeout(() => {
        this.setState({ stopMenuPropagation: false });
      }, 150);
    } else {
      this.setState({ stopMenuPropagation: true });
    }
  };

  goToProfile = (event) => {
    event.preventDefault();
    const { user } = this.context;
    this.props.router.push(`/users/${user.id}`);
  };

  renderPartnerDashboard(auth) {
    const { partner, onClickSwitchPartner } = this.context;
    const { stopStoreMenuPropagation } = this.state;
    const isCurrent = auth.partner_id === partner.id;

    return (
      <DropdownMenuItem key={auth.partner_id} asChild>
        <button
          type="button"
          data-id={auth.partner_id}
          className="nav-partner-dashboard-item"
          onClick={isCurrent ? undefined : onClickSwitchPartner}
          disabled={!isCurrent && stopStoreMenuPropagation}
        >
          <StoreIcon
            store={{ name: auth.partner_name, icon: auth.icon }}
            size={24}
          />
          <span className="nav-partner-dashboard-name">
            {auth.partner_name}
          </span>
          {isCurrent && (
            <span className="nav-partner-dashboard-check">
              <Icon fa="check" />
            </span>
          )}
        </button>
      </DropdownMenuItem>
    );
  }

  onClickTryNewExperience = (event) => {
    event.preventDefault();
    confirmNewExperience(this.context.openModal);
  };

  render() {
    const { nav, location, ...props } = this.props;
    const { storeMenuOpen, footerMenuOpen, stopMenuPropagation } = this.state;
    const { partner, user, session, onClickLogout } = this.context;
    // Swell staff can switch to the new dashboard experience from here
    const showTryNew = Boolean(session?.is_super_admin);
    const navProps = {
      location,
      activeGroups: nav.activeGroups,
      ...props,
    };

    const partnerAuthorizations = user.partner_authorizations || [];

    return (
      <div className="nav-container">
        <Scrollbars>
          <div
            className={showTryNew ? 'nav-inner nav-inner-try-new' : 'nav-inner'}
          >
            <DropdownMenu
              rootRest={{
                modal: false,
                open: storeMenuOpen,
                onOpenChange: this.onStoreMenuChange,
              }}
              contentRest={{
                side: 'bottom',
                align: 'start',
                sideOffset: 4,
                avoidCollisions: false,
              }}
              triggerClassName="nav-store-trigger"
              triggerChildren={
                <>
                  <div className="nav-store-icon">
                    <StoreIcon
                      client={partner}
                      store={{ name: partner.name, icon: partner.icon }}
                      size={48}
                    />
                  </div>
                  <div className="nav-store-name-admin">{partner.name}</div>
                  <div className="nav-store-dropdown-icon">
                    <Icon fa="chevron-down" />
                  </div>
                </>
              }
            >
              <DropdownMenuLabel>Partner accounts</DropdownMenuLabel>
              {this.renderPartnerDashboard(
                partnerAuthorizations.find(
                  (auth) => auth.partner_id === partner.id,
                ) || {
                  partner_id: partner.id,
                  partner_name: partner.name,
                  icon: partner.icon,
                },
              )}
              {partnerAuthorizations
                .filter((auth) => auth.partner_id !== partner.id)
                .map((auth) => this.renderPartnerDashboard(auth))}
            </DropdownMenu>

            {/*partner.verified && (
              <div className="nav-partner-badge-wrap">
                <span className="nav-partner-badge">Swell partner</span>
              </div>
            )*/}
            <NavGroup
              heading=""
              {...navProps}
              items={[
                { label: 'Home', link: '/', icon: 'nav/home' },
                { label: 'Stores', link: '/stores', icon: 'nav/stores' },
                { label: 'Apps', link: '/apps', icon: 'nav/apps' },
                { label: 'Earnings', link: '/earnings', icon: 'nav/reporting' },
                {
                  label: 'Partner page',
                  link: '/partner-page',
                  faIcon: 'book-open',
                },
                { label: 'Users', link: '/users', icon: 'nav/customers' },
              ]}
            />
          </div>
        </Scrollbars>
        <div className="nav-footer-user">
          {showTryNew && (
            <button
              type="button"
              className="nav-try-new"
              onClick={this.onClickTryNewExperience}
            >
              Try the new experience
            </button>
          )}
          <DropdownMenu
            rootRest={{
              modal: false,
              open: footerMenuOpen,
              onOpenChange: this.onFooterMenuChange,
            }}
            contentRest={{ side: 'top', align: 'middle', sideOffset: 12 }}
            triggerRest={{ 'aria-label': 'Nav footer dropdown menu' }}
            triggerClassName="nav-footer-menu-button"
            triggerChildren={
              <>
                <UserPhoto user={user} width={30} height={30} />
                <div className="nav-user-trigger">
                  <div className="nav-user-name">{user.name}</div>
                  <div className="nav-user-email">{user.username}</div>
                </div>
                <Icon fa="ellipsis-h" />
              </>
            }
          >
            <DropdownMenuItem asChild>
              <button
                type="button"
                onClick={this.goToProfile}
                disabled={stopMenuPropagation}
              >
                Edit profile
              </button>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <button
                type="button"
                onClick={onClickLogout}
                disabled={stopMenuPropagation}
              >
                Log out
              </button>
            </DropdownMenuItem>
          </DropdownMenu>
        </div>
      </div>
    );
  }
}
